export default __webpack_public_path__ + "locales/ko-KR/ChangePhoneDialog.json?hash=f18f9346a951d4cd655d1837beeedf9d";